import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FormActionType } from '@rpe/registro-personas-empresas-lib';
import { TecnicoFormComponent } from '../../../entity-tecnicos/components/tecnico-form/tecnico-form.component';
import { TecnicoFormInput } from '../../../entity-tecnicos/entity-tecnicos.model';

import {
  Muestreador,
  MuestreadorFormInput
} from '../../entity-muestreador.model';

@Component({
  selector: 'rpe-muestreador-form',
  templateUrl: './muestreador-form.component.html',
  styleUrls: ['./muestreador-form.component.scss']
})
export class MuestreadorFormComponent implements OnInit {
  @Input()
  set formInput(muestreadorFormInput: MuestreadorFormInput) {
    if (muestreadorFormInput != null) {
      this._formInput = muestreadorFormInput;
      if (muestreadorFormInput.persona != null) {
        this.tecnicoFormInput = {
          action: muestreadorFormInput.action,
          direccion_geografica: muestreadorFormInput.direccion_geografica,
          persona: muestreadorFormInput.persona
        };
      }
    }
  }

  get formInput(): MuestreadorFormInput {
    return this._formInput;
  }

  @Output() formStatusChanges = new EventEmitter<string>();
  @Output() formValueChanges = new EventEmitter<Muestreador>();

  @ViewChild(TecnicoFormComponent, { static: true })
  tecnicoForm: TecnicoFormComponent;

  _formInput: MuestreadorFormInput = null;
  tecnicoFormInput: TecnicoFormInput = null;
  muestreadorFormGroup: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    // Creacion de nuevo muestreador
    if (this.formInput.action == FormActionType.Add) {
      this.muestreadorFormGroup = this.fb.group({
        lugar_trabajo: ['', [Validators.required]],
        descripcion_experiencia: ['', [Validators.required]],
        formacion_ocupacion: ['', [Validators.required]],
        tecnico: this.tecnicoForm.createGroup()
      });
    } else {
    }

    // this.direccionGeograficaForm.setValues(this.formInput.direccion_geografica);

    // emit events
    this.muestreadorFormGroup.valueChanges.subscribe((_) => {
      this.formValueChanges.emit({
        ...this.muestreadorFormGroup.value
      });
    });
    this.muestreadorFormGroup.statusChanges.subscribe((f) =>
      this.formStatusChanges.emit(f)
    );
  }

  reset(): void {}

  onShowErrors(): void {
    this.muestreadorFormGroup.markAllAsTouched();
  }
}
